/**
 * Optimalizovaný Image Preloader s CACHE systémem
 * Řeší problém: "Proč se obrázky načítají znova při každé refresh?"
 */

document.addEventListener('DOMContentLoaded', function() {
    // CACHE SYSTÉM - ukládá načtené obrázky do sessionStorage
    const CACHE_KEY = 'empate_image_cache';
    const CACHE_VERSION = 'v1.0'; // Pro invalidaci cache při změnách
    const MAX_CACHE_SIZE = 100; // Maximální počet obrázků v cache
    
    // Načíst existující cache
    let imageCache = new Set();
    try {
        const cacheData = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{"version":"","urls":[]}');
        if (cacheData.version === CACHE_VERSION) {
            imageCache = new Set(cacheData.urls);
        }
    } catch (e) {
        // console.warn('Cache načítání selhalo, resetuji cache');
        sessionStorage.removeItem(CACHE_KEY);
    }
    
    // Funkce pro uložení cache
    function saveCache() {
        try {
            const cacheArray = [...imageCache];
            // Omezit velikost cache
            if (cacheArray.length > MAX_CACHE_SIZE) {
                imageCache = new Set(cacheArray.slice(-MAX_CACHE_SIZE));
            }
            
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({
                version: CACHE_VERSION,
                urls: [...imageCache]
            }));
        } catch (e) {
            // console.warn('Cache ukládání selhalo:', e);
        }
    }
    
    // Inicializace Image objektů cache pro okamžité zobrazení
    if (!window.empateImageObjects) {
        window.empateImageObjects = new Map();
    }
    
    const elements = document.querySelectorAll('.preload');
    // console.log(`Nalezeno ${elements.length} obrázků k načtení`);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const src = el.getAttribute('data-src');

                if (src) {
                    const isImageTag = el.tagName.toLowerCase() === 'img';

                    // KONTROLA CACHE - pokud už byl obrázek načten
                    if (imageCache.has(src)) {
                        // console.log(`Cache HIT: ${src} - okamžité zobrazení`);

                        // Okamžitě zobrazit z cache bez transition a bez blur efektu
                        el.style.transition = 'none'; // Vypnout transition
                        el.style.filter = 'none'; // Vypnout blur okamžitě

                        if (isImageTag) {
                            el.src = src; // Okamžitě nastavit velký obrázek
                        } else {
                            el.style.backgroundImage = `url("${src}")`;
                        }
                        el.removeAttribute('data-src');
                        el.classList.remove('preload');
                        el.classList.add('loaded');

                        // Obnovit transition po krátké pauze (pro budoucí animace)
                        setTimeout(() => {
                            el.style.transition = '';
                        }, 50);

                        observer.unobserve(el);
                        return;
                    }

                    // NAČÍTÁNÍ NOVÉHO OBRÁZKU
                    // console.log(`Cache MISS: Načítám ${src}`);
                    const newImg = new Image();
                    
                    const applyImage = () => {
                        if (isImageTag) {
                            el.src = src;
                        } else {
                            el.style.backgroundImage = `url("${src}")`;
                        }

                        el.removeAttribute('data-src');
                        el.classList.remove('preload');
                        el.classList.add('loaded');
                        
                        // ULOŽIT DO CACHE + Image objekt
                        imageCache.add(src);
                        
                        // Uložit Image objekt pro okamžité zobrazení při příští návštěvě
                        window.empateImageObjects.set(src, newImg);
                        
                        saveCache();
                        // console.log(`Obrázek načten a uložen do cache + Image objekt: ${src}`);
                    };

                    // Error handling
                    newImg.onerror = () => {
                        // console.warn(`Chyba při načítání obrázku: ${src}`);
                        el.classList.remove('preload');
                        // Neukládáme chybné URL do cache
                    };

                    newImg.src = src;

                    if (newImg.complete && newImg.naturalWidth !== 0) {
                        applyImage();
                    } else {
                        newImg.onload = applyImage;
                    }
                }

                observer.unobserve(el);
            }
        });
    }, {
        rootMargin: '0px',
        threshold: 0.1
    });

    elements.forEach(el => {
        el.parentElement.classList.add('preload_parent');
        observer.observe(el);
    });
    
    // Debug info
    // console.log(`Cache obsahuje ${imageCache.size} obrázků`);
});

// 🧹 ČIŠTĚNÍ CACHE při zavření stránky (volitelné)
window.addEventListener('beforeunload', function() {
    // Můžeme zde přidat logiku pro čištění staré cache
});
